<template>
  <div id="search-product-box" v-if="productDetails">
    <v-layout align-center justify-center row wrap>
      <!-- <v-flex text-xs-right xs11>
        <vue-goodshare-facebook
          has_icon
          :page_url="`https://content.farmerspace.co/product/${$route.params.productId}`"
          title_social="Share"
        ></vue-goodshare-facebook>
      </v-flex>-->
      <v-flex sm6 xs11>
        <div class="display-2 head-page font-weight-bold">{{ productDetails.productname }}</div>
        <div
          class="subheading text-uppercase grey--text spacing"
        >{{ productDetails.productnameeng || '' }}</div>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center row wrap>
      <!-- Product Images -->
      <v-flex my-2 pl-0 sm6 v-if="productImages.length" xs12>
        <v-layout row wrap>
          <v-flex d-flex pa-0 xs7>
            <v-img
              :aspect-ratio="4 / 4"
              class="grey lighten-2"
              cover
              :lazy-src="require('@/assets/NoPicture.png')"
              :src="
                productImages[0].pictureurl
                  ? productImages[0].pictureurl
                  : require('@/assets/NoPicture.png')
              "
            >
              <template v-slot:placeholder>
                <v-layout align-center fill-height justify-center ma-0>
                  <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
          </v-flex>
          <v-flex d-flex pa-0 xs4>
            <v-layout row wrap>
              <v-flex d-flex pb-0 xs12>
                <v-img
                  :aspect-ratio="4 / 4"
                  class="grey lighten-2"
                  cover
                  :lazy-src="require('@/assets/NoPicture.png')"
                  :src="
                    productImages[1].pictureurl
                      ? productImages[1].pictureurl
                      : require('@/assets/NoPicture.png')
                  "
                >
                  <template v-slot:placeholder>
                    <v-layout align-center fill-height justify-center ma-0>
                      <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
              </v-flex>
              <v-flex d-flex pt-0 xs12>
                <v-img
                  :aspect-ratio="4 / 4"
                  class="grey lighten-2"
                  cover
                  :lazy-src="require('@/assets/NoPicture.png')"
                  :src="
                    productImages[2].pictureurl
                      ? productImages[2].pictureurl
                      : require('@/assets/NoPicture.png')
                  "
                >
                  <template v-slot:placeholder>
                    <v-layout align-center fill-height justify-center ma-0>
                      <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center row wrap>
      <v-flex sm6 xs11>
        <div class="font-THSarabunNew" v-html="rawDataText"></div>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center row wrap>
      <v-flex sm6 xs11>
        <div class="font-THSarabunNew">
          {{ `${productDetails.productname}` }}
          {{ `${productDetails.productnameeng ? `(${productDetails.productnameeng})` : ''}` }}
          {{ `${productDetails.typeName ? `เป็น${productDetails.typeName}` : ''}` }}
          {{ `${productDetails.productdescription}` }}
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
// import VueGoodshareFacebook from 'vue-goodshare/src/providers/Facebook.vue'

export default {
  name: 'search-product-box',
  components: {
    // VueGoodshareFacebook
  },
  data() {
    return {}
  },
  props: {
    rawDataText: {
      type: String,
      default: ''
    }
  },
  computed: {
    // replaceDesc() {
    //   return this.productDetails.productdescription.replace(
    //     'productName',
    //     this.productDetails.productname
    //   )
    // },
    productId() {
      return window.atob(this.$route.params.productId)
    },
    productDetails() {
      return this.$store.getters['Product/getProductDetails'].map(item => ({
        productname: item.productname,
        productdescription: item.productdescription,
        mainpictureurl: item.mainpictureurl,
        productnameeng: item.productnameeng,
        typeName: item.typeName
      }))[0]
    },
    productImages() {
      return this.$store.getters['Product/getProductImages']
    }
  },
  created() {
    this.$store.dispatch('Product/fetchProductDetails', this.productId)
    this.$store.dispatch('Product/fetchProductImages', this.productId)
  },
  metaInfo() {
    return {
      // Children can override the title.
      title: this.productDetails ? this.productDetails.productname : '',
      // Result: My Page Title ← My Site
      // If a child changes the title to "My Other Page Title",
      // Define meta tags here.
      meta: [
        {
          vmid: 'title',
          name: 'title',
          content: this.productDetails ? this.productDetails.productname : ''
        },
        {
          vmid: 'description',
          name: 'description',
          content: this.productDetails ? this.productDetails.description : ''
        },
        // OpenGraph data (Most widely used)
        {
          property: 'og:title',
          content: this.productDetails ? this.productDetails.productname : ''
        },
        { property: 'og:site_name', content: 'Farmerspace' },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        {
          property: 'og:url',
          content: `https://content.farmerspace.co/product/${this.$route.params.productId}`
        },
        {
          property: 'og:image',
          content: this.productDetails ? this.productDetails.mainpictureurl : ''
        },
        // Often the same as your meta description, but not always.
        {
          property: 'og:description',
          content: this.productDetails ? this.productDetails.description : ''
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped></style>
